import { api } from "./axios";

export async function getStates() {
    let res = await api.get("state/index");
    if (res) return res.data.data;
    else return false;
}

export async function getStatesNumber() {
    let res = await api.get("state/index/all");
    if (res) return res.data.data;
    else return false;
}

export async function createStates(data) {
    let res = await api.post("state/store", data);
    if (res) return res.data.data;
    else return false;
}
export async function updateStates(id, data) {
    let res = await api.post("state/update/" + id, data);
    if (res) return res.data.data;
    else return false;
}

export async function deleteStates(destroyId) {
    let res = await api.get("state/destroy/" + destroyId);
    if (res) return res.data.status;
    else return false;
}

export async function uploadModelsFile(file) {
    let res = await api.post("import/models", file);
    if (res) return res.data.status;
    else return false;
}

